const MainSearch = class extends HTMLElement {
  constructor() {
    super();

    // Clicking close button
    this.querySelectorAll('.main-search__close').forEach((el) => {
      el.addEventListener('click', (evt) => {
        evt.preventDefault();
        document.body.classList.remove('show-search');
      });
    });

    // Pressing escape key
    this.querySelector('.main-search__input').addEventListener('keyup', (evt) => {
      if (evt.key === 'Escape') {
        this.querySelector('.main-search__close').dispatchEvent(new Event('click'));
      }
    });

    // Search as you type
    if (this.dataset.quickSearch === 'true') {
      this.initQuickSearch();
    }
  }

  initQuickSearch() {
    const searchInput = this.querySelector('.main-search__input');
    const searchTimeoutThrottle = 300; // Hurtigere end før (300ms vs 500ms)
    const resultLimit = 10; // Predictive Search API max per ressource-type
    const includeMeta = this.dataset.quickSearchMeta === 'true';
    let searchTimeoutID = -1;
    let searchAbortController = null;

    const handleInputChange = () => {
      const resultsBox = this.querySelector('.main-search__results');
      const valueToSearch = searchInput.value;

      if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
        this.oldSearchValue = valueToSearch;

        if (searchAbortController !== null) {
          searchAbortController.abort('Existing request not needed');
          searchAbortController = null;
        }

        clearTimeout(searchTimeoutID);

        // URL til fuld søgeside (bruges til "Se alle"-knappen)
        const form = searchInput.closest('form');
        const linkURL = new URL(form.action);
        const formParams = new URLSearchParams(new FormData(form));
        formParams.forEach((value, key) => { linkURL.searchParams.set(key, value); });
        linkURL.searchParams.set('type', 'product');

        // Show loading
        this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--no-results');
        this.classList.add('main-search--loading');
        if (!this.querySelector('.main-search__results-spinner')) {
          resultsBox.innerHTML = '<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>';
        }

        searchTimeoutID = setTimeout(() => {
          searchAbortController = new AbortController();

          // Trin 1: Predictive Search API — hurtigt, synonym-bevidst
          const predictiveUrl = new URL(theme.routes.predictiveSearch, window.location.origin);
          predictiveUrl.searchParams.set('q', valueToSearch);
          predictiveUrl.searchParams.set('section_id', 'predictive-search');
          predictiveUrl.searchParams.set('resources[limit]', resultLimit);
          predictiveUrl.searchParams.set('resources[type]', 'product');
          predictiveUrl.searchParams.set('resources[options][fields]', includeMeta
            ? 'title,product_type,variants.title,vendor,tag,variants.sku'
            : 'title,product_type,variants.title,vendor'
          );

          // Trin 2: Hent totalt antal fra main-search (kører parallelt)
          const countUrl = new URL(linkURL);
          countUrl.searchParams.set('section_id', 'main-search');
          countUrl.searchParams.set('q', valueToSearch + '*');

          const predictiveAbort = new AbortController();
          const countAbort = new AbortController();
          searchAbortController = { abort: (reason) => { predictiveAbort.abort(reason); countAbort.abort(reason); } };

          Promise.all([
            fetch(predictiveUrl, { signal: predictiveAbort.signal }).then(r => r.ok ? r.text() : Promise.reject(r.status)),
            fetch(countUrl, { signal: countAbort.signal }).then(r => r.ok ? r.text() : Promise.reject(r.status))
          ])
            .then(([predictiveHTML, countHTML]) => {
              // Parse predictive resultater
              const predictiveTemplate = document.createElement('template');
              predictiveTemplate.innerHTML = predictiveHTML;
              const resultsList = predictiveTemplate.content.querySelector('.product-grid');

              // Parse totalt antal fra main-search utility-bar
              const countTemplate = document.createElement('template');
              countTemplate.innerHTML = countHTML;
              const countEl = countTemplate.content.querySelector('.utility-bar__centre .utility-bar__item');
              const totalCount = countEl ? countEl.innerText.trim() : null;

              searchAbortController = null;
              this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--no-results');
              resultsBox.innerHTML = '';

              const resultsProducts = document.createElement('div');
              resultsProducts.className = 'main-search__results__products collection-listing';
              resultsProducts.innerHTML = '<div></div>';
              const resultsPages = document.createElement('div');
              resultsPages.className = 'main-search__results__pages';

              if (resultsList) {
                resultsProducts.firstElementChild.className = resultsList.className;

                resultsList.querySelectorAll('.product-block:not(.collection-block):not(.page-block)').forEach((block, index) => {
                  if (index < resultLimit) {
                    block.classList.add('main-search-result');
                    block.querySelectorAll('.btn.quickbuy-toggle').forEach((el) => el.remove());
                    block.querySelectorAll('.quickbuy-toggle').forEach((el) => el.classList.remove('quickbuy-toggle'));
                    resultsProducts.firstElementChild.appendChild(block);
                  }
                });

                resultsList.querySelectorAll('.product-block.page-block').forEach((block) => {
                  const item = document.createElement('a');
                  item.className = 'main-search-result main-search-result--page';
                  item.href = block.querySelector('a').href;
                  item.innerHTML = '<div class="main-search-result__text"></div>';
                  item.firstElementChild.innerText = block.querySelector('.page-block__title').innerText;
                  resultsPages.appendChild(item);
                });
              }

              this.classList.remove('main-search--loading');

              const areProducts = !!resultsProducts.querySelector('.main-search-result');
              const arePages = !!resultsPages.querySelector('.main-search-result');

              if (areProducts || arePages) {
                this.classList.add('main-search--has-results');
                this.classList.toggle('main-search--results-on-multiple-lines', resultsProducts.querySelectorAll('.product-block').length > 0);

                if (areProducts) {
                  // Vis "Viser X ud af Y resultater" øverst
                  if (totalCount) {
                    const shownCount = resultsProducts.querySelectorAll('.main-search-result').length;
                    const countBanner = document.createElement('div');
                    countBanner.className = 'main-search__count';
                    countBanner.innerHTML = `Viser ${shownCount} ud af ${totalCount}`;
                    resultsBox.appendChild(countBanner);
                  }
                  resultsBox.appendChild(resultsProducts);
                }

                if (arePages) {
                  const heading = document.createElement('h6');
                  heading.className = 'main-search-result__heading';
                  heading.innerHTML = theme.strings.generalSearchPages;
                  resultsPages.insertAdjacentElement('afterbegin', heading);
                  resultsBox.appendChild(resultsPages);
                }

                const allLink = document.createElement('a');
                allLink.className = 'main-search__results-all-link btn btn--secondary';
                allLink.href = linkURL;
                allLink.innerHTML = theme.strings.generalSearchViewAll;
                resultsBox.appendChild(allLink);
              } else {
                this.classList.add('main-search--no-results');
                const emptyMessage = document.createElement('div');
                emptyMessage.className = 'main-search__empty-message';
                emptyMessage.innerHTML = theme.strings.generalSearchNoResultsWithoutTerms;
                resultsBox.appendChild(emptyMessage);
              }
            })
            .catch((error) => {
              if (error.name === 'AbortError') return;
              console.warn(error);
            });

        }, searchTimeoutThrottle);

      } else if (!valueToSearch.length) {
        this.oldSearchValue = valueToSearch;
        if (searchAbortController !== null) {
          searchAbortController.abort('Existing request not needed');
          searchAbortController = null;
        }
        clearTimeout(searchTimeoutID);

        this.classList.remove('main-search--has-results', 'main-search--results-on-multiple-lines', 'main-search--loading');
        resultsBox.innerHTML = '';
      }
    };

    searchInput.addEventListener('keyup', handleInputChange.bind(this));
    searchInput.addEventListener('change', handleInputChange.bind(this));
  }
};

window.customElements.define('main-search', MainSearch);